import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '@/store';

import Login from '@/views/Login.vue'
import Home from '@/views/Home.vue'
import Template from '@/views/Template.vue'

import FormulasApp from '@/views/formulas/App.vue'
import Formula from '@/views/formulas/Formula.vue'
import FormulasList from '@/views/formulas/FormulasList.vue'
import FormulasSearch from '@/views/formulas/FormulasSearch.vue'

import SugerenciasApp from '@/views/sugerencias/App.vue'
import Sugerencia from '@/views/sugerencias/Sugerencia.vue'
import SugerenciasList from '@/views/sugerencias/SugerenciasList.vue'
import SugerenciasNotEnded from '@/views/sugerencias/SugerenciasNotEnded.vue'

import BasesApp from '@/views/bases/App.vue'
import Base from '@/views/bases/Base.vue'
import BasesList from '@/views/bases/BasesList.vue'

import AditivosApp from '@/views/aditivos/App.vue'
import Aditivo from '@/views/aditivos/Aditivo.vue'
import AditivosList from '@/views/aditivos/AditivosList.vue'


import ColoresApp from '@/views/colores/App.vue'
import Color from '@/views/colores/Color.vue'
import ColoresList from '@/views/colores/ColoresList.vue'


import AplicacionesApp from '@/views/aplicaciones/App.vue'
import Aplicacion from '@/views/aplicaciones/Aplicacion.vue'
import AplicacionesList from '@/views/aplicaciones/AplicacionesList.vue'


import ProveedoresApp from '@/views/proveedores/App.vue'
import Proveedor from '@/views/proveedores/Proveedor.vue'
import ProveedoresList from '@/views/proveedores/ProveedoresList.vue'

import UtilidadesApp from '@/views/utilidades/App.vue'
import Utilidad from '@/views/utilidades/Utilidad.vue'
import UtilidadesList from '@/views/utilidades/UtilidadesList.vue'


Vue.use(VueRouter)


export const formulasPages = [
  {
    path: '/formulas-listado',
    name: 'FormulasList',
    nameToShow: "Listado",
    icon: 'mdi-text',
    active: false,
    component: FormulasList,
    meta: { requiresAuth: true },
    show: true,
  },
  {
    path: '/formulas-search',
    name: 'FormulasSearch',
    nameToShow: "Buscar",
    icon: 'mdi-magnify',
    active: false,
    component: FormulasSearch,
    meta: { requiresAuth: true },
    show: true,
  },
  {
    path: '/formulas-add',
    name: 'FormulasAdd',
    nameToShow: "Añadir Formula",
    icon: 'mdi-plus-outline',
    active: false,
    component: Formula,
    meta: { requiresAuth: true },
    show: true,
  },
  {
    path: '/formulas/:id',
    name: 'FormulaId',
    nameToShow: "Formula",
    component: Formula,
    meta: { requiresAuth: true },
    props: true,
  },
];

export const sugerenciasPages = [
  {
    path: '/sugerencias-listado',
    name: 'SugerenciasList',
    nameToShow: "Listado",
    icon: 'mdi-text',
    active: false,
    component: SugerenciasList,
    meta: { requiresAuth: true },
    show: true,
  },
  {
    path: '/sugerencias-add',
    name: 'SugerenciasAdd',
    nameToShow: "Nueva búsqueda",
    icon: 'mdi-magnify',
    active: false,
    component: Sugerencia,
    meta: { requiresAuth: true },
    show: true,
  },
  {
    path: '/sugerencias/:id',
    name: 'SugerenciaId',
    nameToShow: "Sugerencia",
    component: Sugerencia,
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: '/sugerencias-encurso',
    name: 'SugerenciasNotEnded',
    nameToShow: "Sin terminar",
    icon: 'mdi-clock',
    active: false,
    component: SugerenciasNotEnded,
    meta: { requiresAuth: true },
    show: true,
  },
];

export const basesPages = [
  {
    path: '/bases-listado',
    name: 'BasesList',
    nameToShow: "Listado",
    icon: 'mdi-text',
    active: false,
    component: BasesList,
    meta: { requiresAuth: true },
    show: true,
  },
  {
    path: '/bases-add',
    name: 'BasesAdd',
    nameToShow: "Añadir Base",
    icon: 'mdi-plus-outline',
    active: false,
    component: Base,
    meta: { requiresAuth: true },
    show: true,
  },
  {
    path: '/bases/:id',
    name: 'BaseId',
    nameToShow: "Base",
    component: Base,
    meta: { requiresAuth: true },
    props: true,
  },
];

export const aditivosPages = [
  {
    path: '/aditivos-listado',
    name: 'AditivosList',
    nameToShow: "Listado",
    icon: 'mdi-text',
    active: false,
    component: AditivosList,
    meta: { requiresAuth: true },
    show: true,
  },
  {
    path: '/aditivos-add',
    name: 'AditivosAdd',
    nameToShow: "Añadir Aditivo",
    icon: 'mdi-plus-outline',
    active: false,
    component: Aditivo,
    meta: { requiresAuth: true },
    show: true,
  },
  {
    path: '/aditivos/:id',
    name: 'AditivoId',
    nameToShow: "Aditivo",
    component: Aditivo,
    meta: { requiresAuth: true },
    props: true,
  },
];

export const coloresPages = [
  {
    path: '/colores-listado',
    name: 'ColoresList',
    nameToShow: "Listado",
    icon: 'mdi-text',
    active: false,
    component: ColoresList,
    meta: { requiresAuth: true },
    show: true,
  },
  {
    path: '/colores-add',
    name: 'ColoresAdd',
    nameToShow: "Añadir Color",
    icon: 'mdi-plus-outline',
    active: false,
    component: Color,
    meta: { requiresAuth: true },
    show: true,
  },
  {
    path: '/colores/:id',
    name: 'ColorId',
    nameToShow: "Color",
    component: Color,
    meta: { requiresAuth: true },
    props: true,
  },
];

export const aplicacionesPages = [
  {
    path: '/aplicaciones-listado',
    name: 'AplicacionesList',
    nameToShow: "Listado",
    icon: 'mdi-text',
    active: false,
    component: AplicacionesList,
    meta: { requiresAuth: true },
    show: true,
  },
  {
    path: '/aplicaciones-add',
    name: 'AplicacionesAdd',
    nameToShow: "Añadir Aplicación",
    icon: 'mdi-plus-outline',
    active: false,
    component: Aplicacion,
    meta: { requiresAuth: true },
    show: true,
  },
  {
    path: '/aplicaciones/:id',
    name: 'AplicacionId',
    nameToShow: "Aplicacion",
    component: Aplicacion,
    meta: { requiresAuth: true },
    props: true,
  },
];

export const utilidadesPages = [
  {
    path: '/utilidades-listado',
    name: 'UtilidadesList',
    nameToShow: "Listado",
    icon: 'mdi-text',
    active: false,
    component: UtilidadesList,
    meta: { requiresAuth: true },
    show: true,
  },
  {
    path: '/utilidades-add',
    name: 'UtilidadesAdd',
    nameToShow: "Añadir Utilidad",
    icon: 'mdi-plus-outline',
    active: false,
    component: Utilidad,
    meta: { requiresAuth: true },
    show: true,
  },
  {
    path: '/utilidades/:id',
    name: 'UtilidadId',
    nameToShow: "Utilidad",
    component: Utilidad,
    meta: { requiresAuth: true },
    props: true,
  },
];

export const proveedoresPages = [
  {
    path: '/proveedores-listado',
    name: 'ProveedoresList',
    nameToShow: "Listado",
    icon: 'mdi-text',
    active: false,
    component: ProveedoresList,
    meta: { requiresAuth: true },
    show: true,
  },
  {
    path: '/proveedores-add',
    name: 'ProveedoresAdd',
    nameToShow: "Añadir Proveedor",
    icon: 'mdi-plus-outline',
    active: false,
    component: Proveedor,
    meta: { requiresAuth: true },
    show: true,
  },
  {
    path: '/proveedores/:id',
    name: 'ProveedorId',
    nameToShow: "Proveedor",
    component: Proveedor,
    meta: { requiresAuth: true },
  },
];

export const pages = [
  {
    path: '/',
    name: 'root',
    nameToShow: "Home",
    icon: "mdi-home",
    active: false,
    component: Home,
    meta: { requiresAuth: true },
  },
  {
    path: '/home',
    name: 'home',
    nameToShow: "Home",
    icon: "mdi-home",
    active: false,
    component: Home,
    meta: { requiresAuth: true },
  },
  {
    path: '/sugerencias',
    name: 'Sugerencias',
    nameToShow: "Sugerencias IA",
    icon: 'mdi-brain',
    active: false,
    component: SugerenciasApp,
    meta: { requiresAuth: true },
    show: true,
    children: sugerenciasPages
  },
  {
    path: '/formulas',
    name: 'Formulas',
    nameToShow: "Formulas",
    icon: 'mdi-view-dashboard',
    active: false,
    component: FormulasApp,
    meta: { requiresAuth: true },
    show: true,
    children: formulasPages
  },
  {
    path: '/bases',
    name: 'Bases',
    nameToShow: "Bases",
    icon: 'mdi-flask-outline',
    active: false,
    component: BasesApp,
    meta: { requiresAuth: true },
    show: true,
    children: basesPages
  },
  {
    path: '/aditivos',
    name: 'Aditivos',
    nameToShow: "Aditivos",
    icon: 'mdi-flask-plus',
    active: false,
    component: AditivosApp,
    meta: { requiresAuth: true },
    show: true,
    children: aditivosPages
  },
  {
    path: '/colores',
    name: 'Colores',
    nameToShow: "Colores",
    icon: 'mdi-palette',
    active: false,
    component: ColoresApp,
    meta: { requiresAuth: true },
    show: true,
    children: coloresPages
  },
  {
    path: '/aplicaciones',
    name: 'Aplicaciones',
    nameToShow: "Aplicaciones",
    icon: 'mdi-application',
    active: false,
    component: AplicacionesApp,
    meta: { requiresAuth: true },
    show: true,
    children: aplicacionesPages
  },
  {
    path: '/utilidades',
    name: 'Utilidades',
    nameToShow: "Utilidades",
    icon: 'mdi-tools',
    active: false,
    component: UtilidadesApp,
    meta: { requiresAuth: true },
    show: true,
    children: utilidadesPages
  },
  {
    path: '/proveedores',
    name: 'Proveedores',
    nameToShow: "Proveedores",
    icon: 'mdi-briefcase-arrow-left-right',
    active: false,
    component: ProveedoresApp,
    meta: { requiresAuth: true },
    show: true,
    children: proveedoresPages,
  },
];

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: "/",
    component: Template,
    children: pages,
    meta: { requiresAuth: true },
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isAuthenticated) {
      next();
      window.scrollTo(0, 0)
      return;
    }
    next('/login');
    window.scrollTo(0, 0)
  } else {
    next();
    window.scrollTo(0, 0)
  }
});

export default router
